import QueryOutputSection from "./QueryOutputSection/QueryOutputSection";
import QueryRunSection from "./QueryRunSection/QueryRunSection";
import "./QuerySection.scss";

function QuerySection({ resourceId, systemUserId, selectedDatabase, setSelectedDatabase, databaseInfo, resourceAccessID, refreshTrigger }) {
  return (
    <div className="database-gui-query-section-container">
      <QueryRunSection 
        resourceId={resourceId} 
        systemUserId={systemUserId} 
        selectedDatabase={selectedDatabase}
        setSelectedDatabase={setSelectedDatabase}
        databaseInfo={databaseInfo}
        resourceAccessID={resourceAccessID}
        refreshTrigger={refreshTrigger}
      />
    </div>
  );
}

export default QuerySection;
